var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add_circle_black_16dp-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 328,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "0403\\u66F4\\u65B0--my-balance\\u5F39\\u7A97--send1",
    transform: "translate(-768.000000, -559.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27",
    transform: "translate(500.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-40",
    transform: "translate(16.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-39",
    transform: "translate(194.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add_circle_black_16dp-4",
    transform: "translate(58.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 16 0 16 16 0 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,1.33333333 C4.32,1.33333333 1.33333333,4.32 1.33333333,8 C1.33333333,11.68 4.32,14.6666667 8,14.6666667 C11.68,14.6666667 14.6666667,11.68 14.6666667,8 C14.6666667,4.32 11.68,1.33333333 8,1.33333333 Z M11.3333333,8.66666667 L8.66666667,8.66666667 L8.66666667,11.3333333 L7.33333333,11.3333333 L7.33333333,8.66666667 L4.66666667,8.66666667 L4.66666667,7.33333333 L7.33333333,7.33333333 L7.33333333,4.66666667 L8.66666667,4.66666667 L8.66666667,7.33333333 L11.3333333,7.33333333 L11.3333333,8.66666667 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add_circle.4e1e5a0fe195c98e65576ea5e877f3cb.svg";
export { ForwardRef as ReactComponent };